// Matches Company Profile's `domains` chip pill exactly (Components/common/ChipsInput/styles.js) —
// the one look the app should use for every multi-select tag chip, in place of MUI's default grey.
export const tagChipSx = {
  backgroundColor: 'var(--vo-capri-50)',
  color: 'var(--vo-celeste)',
  borderRadius: '20px',
  fontFamily: "'Maven Pro', sans-serif",
  fontSize: '12px',
  fontWeight: 500,
  border: 'none',
  '& .MuiChip-deleteIcon': {
    color: 'var(--vo-celeste)',
    '&:hover': { opacity: 0.7 },
  },
}
